import React from 'react';
import { Modal, Box } from '@mui/material';

const modalStyle = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '90vw',
  maxWidth: 440,
  maxHeight: '88vh',
  overflowY: 'auto',
  bgcolor: 'var(--surface)',
  boxShadow: 'var(--soft-shadow-lg)',
  p: '24px 22px',
  outline: 'none',
};

const Rule = ({ emoji, children }) => (
  <li className="sg-row" style={{ alignItems: 'flex-start', gap: 12, listStyle: 'none' }}>
    <span style={{ fontSize: '1.3rem', lineHeight: 1.3, flexShrink: 0 }} aria-hidden="true">{emoji}</span>
    <span style={{ lineHeight: 1.4, paddingTop: 2 }}>{children}</span>
  </li>
);

const ExplainerPopup = ({ open, onClose }) => {
  return (
    <Modal
      open={open}
      onClose={onClose}
      aria-labelledby="spellago-rules-title"
      aria-describedby="spellago-rules-description"
    >
      <Box sx={modalStyle} className="sg-modal-paper sg-anim-pop">
        <div className="sg-center-col" style={{ padding: 0 }}>
          <p className="sg-kicker" style={{ margin: '0 0 6px' }}>The basics</p>
          <h2 id="spellago-rules-title" style={{ fontSize: '1.7rem', margin: '0 0 16px' }}>
            How to play
          </h2>

          <ul id="spellago-rules-description" className="sg-stack sg-stagger" style={{ margin: 0, padding: 0, gap: 14 }}>
            <Rule emoji="🔤">
              Take turns revealing letters.
            </Rule>
            <Rule emoji="✨">
              Spell a word with 3+ revealed letters (T, C, A → <strong>CAT</strong>).
            </Rule>
            <Rule emoji="🎯">
              Score = word length − 2. Longer words = more points.
            </Rule>
            <Rule emoji="🪄">
              Steal: add a letter to someone's word to make a <strong>new</strong> word (CAT → ACTS or CAST, but not CATS).
            </Rule>
            <Rule emoji="🏆">
              Most points when the bag runs out wins!
            </Rule>
          </ul>

          <div className="sg-row" style={{ justifyContent: 'center', marginTop: 22 }}>
            <button type="button" className="sg-btn sg-btn--primary" onClick={onClose}>
              Got it
            </button>
          </div>
        </div>
      </Box>
    </Modal>
  );
};

export default ExplainerPopup;
